import { safeJsonParse } from "./json";
import { userIdFromIdentity } from "./identity";

export const getRoleImageFromMetaOrApi = (participant, apiUserMap, rosterById = null) => {
    const meta = safeJsonParse(participant?.metadata) || {};

    // ✅ Step 1: extract userId from metadata or identity string
    const uid = meta?.userId || userIdFromIdentity(participant?.identity || "");

    // ✅ Step 2: look up in join-time snapshot (apiUserMap)
    const api = uid ? apiUserMap?.[uid] : null;

    // ✅ Step 3: look up in live roster (rosterById Map) as authoritative fallback
    const roster = uid && rosterById ? rosterById.get(String(uid)) : null;

    return {
        userId: uid || api?._id || roster?._id || null,
        name:
            meta?.userName ||
            meta?.name ||
            roster?.name ||       // ✅ roster is more up-to-date than api snapshot
            api?.name ||
            participant?.name ||
            participant?.identity ||
            "Unknown",
        image:
            meta?.image ||
            roster?.image ||      // ✅ roster fallback
            api?.image ||
            null,
        role:
            meta?.role ||
            roster?.role ||       // ✅ roster fallback
            api?.role ||
            "participant",
        networkingRole:
            meta?.networkingRole ||
            roster?.networkingRole ||   // ✅ roster is authoritative
            api?.networkingRole ||
            null,
        networkingIntent:
            meta?.networkingIntent ||
            roster?.networkingIntent || // ✅ roster is authoritative
            api?.networkingIntent ||
            null,
    };
};